import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import NotificationTemplateComponent from '../inbox/notifications/notification-component';
import { isNotificationTypeValid } from './constants';

const mapStateToProps = state => ({
  user: state.Dashboard.user,
  booking: state.Booking
});

class DashboardNotification extends PureComponent {
  constructor(props) {
    super(props);
  }

  compareNotifications(a, b) {
    let a_createdDate = moment(a.createdDate);
    let b_createdDate = moment(b.createdDate);
    if (b_createdDate.isBefore(a_createdDate)) return -1;
    else if (b_createdDate.isAfter(a_createdDate)) return 1;
    else return 0;
  }

  getNotificationList(notifications, type, limit) {
    let notificationList = notifications.filter(n => n.level > 0 && !n.dismissed && isNotificationTypeValid(n.notificationType, type))
      .sort(this.compareNotifications);
    if (limit) {
      return notificationList.slice(0, limit);
    }
    return notificationList;
  }

  getUrgentNotificationList(notifications, type) {
    return notifications.filter(n => n.level === 0 && !n.dismissed && isNotificationTypeValid(n.notificationType, type));
  }

  renderUrgent() {
    return (<div className="col">(!)</div>)
  }

  render() {
    let { user, booking, type, limit } = this.props;
    let urgentNotifications = user.notifications ? this.getUrgentNotificationList(user.notifications, type) : [];
    let normalNotifications = user.notifications ? this.getNotificationList(user.notifications, type, limit) : [];
    if (urgentNotifications.length === 0 && normalNotifications.length === 0) {
      return (<div className="notification-container"><h5>No Notifications</h5></div>)
    }
    return (<div className="notification-container">
      {!!booking && booking.bookings && booking.listingBookings &&
        !!urgentNotifications.length &&
        urgentNotifications.map(n => {

          let b = booking.bookings.filter(b => b._id === n.booking)[0];
          if (!b) { b = booking.listingBookings.filter(b => b._id === n.booking)[0]; }
          return (<NotificationTemplateComponent key={`n-urgent-${n._id}`} notification={n} booking={b} />)
        })}
      {!!booking && booking.bookings && booking.listingBookings &&
        !!normalNotifications.length &&
        normalNotifications.map(n => {
          let b = booking.bookings.filter(b => b._id === n.booking)[0];
          if (!b) { b = booking.listingBookings.filter(b => b._id === n.booking)[0]; }
          return (<NotificationTemplateComponent key={`n-${n._id}`} notification={n} booking={b} />)
        })}
    </div>);

  }
}

export default withRouter(connect(mapStateToProps)(DashboardNotification));
